module.exports = __webpack_public_path__ + "img/elaterna-header-timeline_1920x120px.e1a8ca26.jpg";